/**
 * @file Input component for checkboxes input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { OnChanges, ChangeDetectorRef } from '@angular/core';
import { InputBase } from '../input-base/input-base';
import { FormGroup, FormControl } from '@angular/forms';
/**
 * Class for input component for checkboxes input
 */
var InputCheckboxesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputCheckboxesComponent, _super);
    /**
     * Constructs a InputCheckboxesComponent.
     * @param cdRef Is used to detect changes.
     */
    function InputCheckboxesComponent(cdRef) {
        var _this = _super.call(this) || this;
        _this.cdRef = cdRef;
        /** Name of block that configures this instance. */
        _this.blockName = undefined;
        /**
         * Form Group of checkboxes
         * @memberOf InputCheckboxesComponent
         */
        _this.checkBoxGroup = new FormGroup({});
        /** The values to be displayed. */
        _this.valueLabelKeys = [];
        /** List of values and label keys of the options. */
        _this._format = undefined;
        return _this;
    }
    Object.defineProperty(InputCheckboxesComponent.prototype, "format", {
        /** Gets the list of values and label keys of the options. */
        get: function () {
            return this._format;
        },
        /** Sets the options and checks whether the value is one of the options' keys. */
        set: function (value) {
            var _this = this;
            if (this._format === value) {
                return;
            }
            this._format = value;
            this.valueToLabel();
            this.checkBoxGroup.reset({});
            if (value == null) {
                return;
            }
            value.forEach(function (item) {
                var control = new FormControl();
                _this.checkBoxGroup.addControl(item.value + '', control);
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the values and label keys.
     * @param val The space separated keys of the checked values.
     */
    InputCheckboxesComponent.prototype.setValue = function (val) {
        _super.prototype.setValue.call(this, val);
        this.valueToLabel();
    };
    /**
     * Sets the display values to the label keys based on the value.
     */
    InputCheckboxesComponent.prototype.valueToLabel = function () {
        var _this = this;
        this.valueLabelKeys = [];
        if (!this.value || !this.value.split || !this.format) {
            return;
        }
        var keys = Object.keys(this.format);
        var values = this.value.split(' ');
        values.forEach(function (item) {
            var index = keys.find(function (key) { return _this.format[key].value === item; });
            if (index) {
                _this.valueLabelKeys.push(_this.format[index].labelKey);
            }
        });
    };
    /**
     * Hook method called in the angular 2 lifecycle.
     */
    InputCheckboxesComponent.prototype.ngOnChanges = function () {
        this.cdRef.detectChanges();
    };
    return InputCheckboxesComponent;
}(InputBase));
export { InputCheckboxesComponent };
